import { render, staticRenderFns } from "./CorreosChileTrazabilidadComponent.vue?vue&type=template&id=27a52572&"
import script from "./CorreosChileTrazabilidadComponent.vue?vue&type=script&lang=js&"
export * from "./CorreosChileTrazabilidadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports